module.exports = __webpack_public_path__ + "media/images/gift_plan/character-img-introduction-fd8bf1bce80143f83cc6849bac55f979.png";